import React, { useRef, useEffect, useState } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";

const QuillEditor = ({ value, onChange }) => {
  const quillRef = useRef(null);
  const [quillInstance, setQuillInstance] = useState(null);

  const toolbarOptions = [
    ["bold", "italic", "underline", "strike"],
    ["blockquote", "code-block"],
    [{ header: 1 }, { header: 2 }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ direction: "rtl" }],
    [{ size: ["small", false, "large", "huge"] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
    ["clean"],
    ["image"],
  ];

  useEffect(() => {
    if (quillRef.current) {
      const quill = new Quill(quillRef.current, {
        theme: "snow",
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: () => selectLocalImage(quill),
            },
          },
        },
      });

      quill.on("text-change", () => {
        onChange(quill.root.innerHTML);
      });

      setQuillInstance(quill);
    }
  }, []);

  // Gunakan useEffect untuk memperbarui konten editor saat `value` berubah
  useEffect(() => {
    if (quillInstance && value !== quillInstance.root.innerHTML) {
      quillInstance.root.innerHTML = value;
    }
  }, [value, quillInstance]);

  const selectLocalImage = (quill) => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = () => {
      const file = input.files[0];
      const reader = new FileReader();

      reader.onload = () => {
        const base64Image = reader.result;
        const range = quill.getSelection();
        quill.insertEmbed(range.index, "image", base64Image);
      };

      if (file) {
        reader.readAsDataURL(file);
      }
    };
  };

  return <div ref={quillRef} style={{ height: "400px" }} />;
};

export default QuillEditor;
